import {Component, Input, Output, EventEmitter} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'admin-nav',
  templateUrl: './admin-nav.template.html',
  styleUrls: ['admin-nav.style.css']
})

export class AdminNavComponent {
  data: any;

  @Input() type: string;

  public menuHide = false;
  public user: any;
  public nav: string = '/dashboard';

  isOpen = false;

  constructor(
    private router: Router
  ) {
    this.nav = this.router.url;
    if (localStorage.getItem('User')) {
      this.user = JSON.parse(localStorage.getItem('User'));
    }
  }

  openSubMenu() {
    this.isOpen = !this.isOpen;
  }

  on_click(url) {
    $('.main-content').css('display','block');
    $('.tab-content').css('display','none');
    this.nav = url;
    this.router.navigate([url]);
  }

  toggleMenu() {
    if (!this.menuHide) {
      $('.site-menubar').addClass('menu_hide');
      $('#evs_page').addClass('has_menu');
      this.menuHide = true;
    } else {
      $('.site-menubar').removeClass('menu_hide');
      $('#evs_page').removeClass('has_menu');
      this.menuHide = false;
    }
  }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/layout/navigation/admin-nav.component.ts